export default {
    countries:          [],
    states:             [],
    cities:             [],
    // citiesPromise:      null,
    // countriesPromise:   null,
    // statesPromise:      null,
}